// extracted by mini-css-extract-plugin
module.exports = {"charactes":"styles_charactes__ij-8i"};